import React from "react";
import "./ProjectCard.css"
// import { SwiperSlide } from "swiper/react";

function ProjectCard(props){
    return(
        <div className="project-card">
            <div className="project-img-container">
                <img className="project-img" src={props.project_img} alt='cardImage'></img>
            </div>
            <div className="project-name">{props.project_name}</div>
            
            <div className="project-desc">{props.project_desc}</div>
            <div className="project-link"><a href={props.project_link} target="_blank" rel="noreferrer">VIEW PROJECT</a></div>
        </div>
    );
}

export default ProjectCard;